import { ResolveFn } from '@angular/router';
import { CasiStoryStatus } from '../models/models.lib';
import { inject } from '@angular/core';
import { UserStoryStatusService } from '../tracker/user-story-status.service';

export const casiStoryStatusResolver: ResolveFn<CasiStoryStatus> = (route, state) => {
  return inject(UserStoryStatusService).get();
};
